import { WORKFLOWS_MODERN_EDITOR } from '../../constants/gates';
import { useGate } from '../useGate';
export const useIsUngatedForModernEditor = () => useGate(WORKFLOWS_MODERN_EDITOR);